import React, { useState } from 'react';
import axios from 'axios';
import { Helmet } from 'react-helmet';
import './Register.css';
import GoogleButton from './GoogleButton';

const Register = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [username, setUsername] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  const validateForm = () => {
    if (!username || username.length < 3 || username.length > 30) {
      setError('Username must be between 3 and 30 characters');
      return false;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!email || !emailRegex.test(email)) {
      setError('Please enter a valid email address');
      return false;
    }

    if (!password || password.length < 8) {
      setError('Password must be at least 8 characters long');
      return false;
    }

    const commonPasswords = ['password123', '12345678', 'qwerty123'];
    if (commonPasswords.includes(password.toLowerCase())) {
      setError('Please choose a stronger password');
      return false;
    }

    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setMessage('');

    if (!validateForm()) {
      return;
    }

    try {
      const response = await axios.post(`${process.env.REACT_APP_API_URL}/api/register`, {
        email,
        password,
        username
      });
      setMessage('Registration successful!');
      // Clear form
      setEmail('');
      setPassword('');
      setUsername('');
    } catch (error) {
      const errorMessage = error.response?.data?.error || 'Registration failed. Please try again.';
      setError(errorMessage);
      console.error('Registration error:', error);
    }
  };

  const handleGoogleSignup = () => {
    window.location.href = `${process.env.REACT_APP_API_URL}/auth/google`;
  };

  return (
    <div className="container mt-5 register-container">
      <Helmet>
        <title>Register - The Other Side</title>
        <meta name="description" content="Register on The Other Side to unlock premium content, personalize your feed, save your favorite articles and videos, and engage with the community." />
        <meta name="keywords" content="register, premium content, personalized feed, save articles, community engagement" />
        <link rel="canonical" href="https://www.theotherside.media/register" />
      </Helmet>
      <div className="row">
        <div className="col-md-6">
          <h2>Sign Up Here</h2>
          {message && <div className="alert alert-success">{message}</div>}
          {error && <div className="alert alert-danger">{error}</div>}

          <GoogleButton onClick={handleGoogleSignup} />

          <div className="divider">
            <span>or</span>
          </div>

          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="registerEmail">Email address</label>
              <input
                type="email"
                className="form-control"
                id="registerEmail"
                placeholder="Enter email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>
            <div className="form-group">
              <label htmlFor="registerUsername">Username</label>
              <input
                type="text"
                className="form-control"
                id="registerUsername"
                placeholder="Enter username"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                required
              />
            </div>
            <div className="form-group">
              <label htmlFor="registerPassword">Password</label>
              <input
                type="password"
                className="form-control"
                id="registerPassword"
                placeholder="Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </div>
            <button type="submit" className="btn btn-primary">Register</button>
          </form>
        </div>
        <div className="col-md-6 register-benefits">
          <h4>Why Register?</h4>
          <ul>
            <li>Be the first to hear about new topics and features.</li>
            <li>Join the discussion by leaving comments on subtopic pages.</li>
            <li>Stay informed with updates delivered straight to your inbox.</li>
            <li>Help shape the future of the platform with your feedback.</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Register;
